export interface IUserForPurchase {
  ID: string;
  email: string;
  userName: string;
}

export class UserForPurchase implements IUserForPurchase {
  public ID: string;
  public email: string;
  public userName: string;

  constructor({ ID, email, userName }: IUserForPurchase) {
    this.ID = ID;
    this.email = email;
    this.userName = userName;
  }
}
